import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { getSocket } from './useConvPresencia'

// ══════════════════════════════════════════════════════════════════════════════════════════════
//  B-048 · LAS CITAS EN VIVO
// ══════════════════════════════════════════════════════════════════════════════════════════════
//  El panel de recepción, el modo auxiliar y la agenda preguntaban por las citas cada 30 s, hubiera
//  cambios o no. Ahora el servidor mira si han cambiado las citas de ESTA clínica y lo avisa por el
//  socket (backend/socketCitas.js: el aviso no lleva ningún dato), y aquí se marcan para volver a
//  pedirlas. Estas son las consultas de citas de esas tres pantallas (Dashboard, ModoAuxiliar y
//  Agenda: sus claves empiezan así).
//
//  `window.__biangoCitasEnVivo` les dice a esas pantallas cada cuánto preguntar por su cuenta: con el
//  aviso funcionando, cada 5 minutos por si acaso; sin él (sin socket, o el servidor sin poder mirar la
//  base), cada 30 segundos, como siempre. Lo lee su `refetchInterval`, escrito en cada pantalla.
//
//  Lo monta `useNotifications`, que montan los DOS armazones de la app con sesión (Layout y
//  AdminLayout), una sola vez.
export const CLAVES_CITAS = [['citasHoy'], ['citas-hoy'], ['citas-hoy-codoctores'], ['citas']]

export function useCitasEnVivo() {
  const qc = useQueryClient()
  useEffect(() => {
    let s = null
    try { s = getSocket() } catch (_) { return undefined }
    if (!s || typeof s.on !== 'function') return undefined
    const marcar = () => { for (const k of CLAVES_CITAS) qc.invalidateQueries({ queryKey: k }) }
    const pedirEstado = () => { try { s.emit('citas:estado') } catch (_) { /* sin socket, se sigue preguntando */ } }
    const enVivo = (d) => { window.__biangoCitasEnVivo = !!(d && d.activo === true) }
    const fuera = () => { window.__biangoCitasEnVivo = false }
    // La primera conexión solo pregunta si el aviso funciona (las citas se acaban de cargar); una
    // RECONEXIÓN además las vuelve a pedir, porque lo que cambió durante el corte no se avisó.
    const gestor = s.io && typeof s.io.on === 'function' ? s.io : null
    s.on('connect', pedirEstado)
    s.on('citas:en-vivo', enVivo)
    s.on('disconnect', fuera)
    s.on('citas:cambio', marcar)
    if (gestor) gestor.on('reconnect', marcar)
    if (s.connected) pedirEstado()
    return () => {
      s.off('connect', pedirEstado); s.off('citas:en-vivo', enVivo); s.off('disconnect', fuera); s.off('citas:cambio', marcar)
      if (gestor) gestor.off('reconnect', marcar)
      window.__biangoCitasEnVivo = false
    }
  }, [qc])
}
